export default "__VITE_ASSET__FdRHH_jf__"